// extracted by mini-css-extract-plugin
module.exports = {"container":"Co-z","creativeContainer":"Do-z","copy":"Eo-z","cta":"Fo-z","disabled":"Go-z","flipped":"Ho-z","card":"Io-z"};